/**
 * @name Dimension.service
 * @author Evan Moon
 */
var DimensionService = /** @class */ (function () {
    function DimensionService() {
        this.scale = 1;
    }
    DimensionService.prototype.setLargestDimension = function (dim) {
        this.scale = 1000 / dim;
    };
    DimensionService.prototype.getScaledVector = function (obj) {
        return obj.multiplyScalar(this.scale);
    };
    DimensionService.prototype.getScaled = function (obj) {
        return obj * this.scale;
    };
    return DimensionService;
}());
var instance = new DimensionService();
export default instance;
